export default {"src":"/_next/static/media/NFLX.5e32c03e.svg","height":18,"width":18};